import * as S from "./CategoryTab.styled";

type Props = {
  value?: string;
  options: { label: string; value: string }[];
  onChange?: (value: string) => void;
};

export const CategoryTab = ({ onChange, options, value }: Props) => {
  return (
    <S.TabContainer>
      {options.map((option, i) => (
        <S.Tab active={option.value === value} key={`${option.value}-${i + 1}`}>
          <S.Input
            type="radio"
            id={`${option.value}-${i + 1}`}
            name="category-tab"
            value={option.value}
            onChange={(e) => onChange?.(e.currentTarget.value)}
            defaultChecked={option.value === value}
          />
          {option.label}
        </S.Tab>
      ))}
    </S.TabContainer>
  );
};
